<template>
  <div class="page-banner-area bg-secondary">
    <div class="container mw-1720">
      <div class="page-banner-content">
        <ul class="d-flex align-items-center ps-0 list-unstyled bredcrounbs">
          <li>
            <RouterLink to="/">الرئيسية</RouterLink>
          </li>
          <li>
            <span>المتجر</span>
          </li>
        </ul>
        <h2>
          اكتشف، اختر، وارتقِ بتجربتك الترفيهية الرقمية: غص في عالم مليء
          بالخيارات اللامحدودة مع متجرنا الخاص.
        </h2>
      </div>
    </div>

    <div class="container mw-1356">
      <div
        class="blast-off-bg bg-img rounded-2"
        :style="{
          backgroundImage: `url(${require('@/assets/images/blast-off-bg.jpg')})`,
        }"
      >
        <div class="row align-items-center" data-cues="zoomOut">
          <div class="col-lg-6 col-md-6">
            <div class="blast-off-content mw-100">
              <h2 class="text-golden">انطلق الآن مع أقوى عروض السيرفرات الذكية</h2>
              <p>
                مع سيرفرات IPTV فائقة الثبات والسرعة، اتصل، شاهد، واستمتع بأقوى المباريات والأفلام بجودة لم تشهدها من قبل.
              </p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="blast-off-img">
              <img src="@/assets/images/blast-off.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <img
      src="@/assets/images/shape-20.png"
      class="shape-21 shape"
      alt="shape"
    />
    <img
      src="@/assets/images/shape-21.png"
      class="shape-22 shape"
      alt="shape"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageBanner",
});
</script>